export const API_BASE_URL = "http://68.183.141.45:8080/v1";
export const ACCESS_TOKEN = "accessToken";
export const PAGE_SIZE = 15;
